export class ErrorResponse {
  constructor(data) {
    this.error = data.message;
    this.httpStatus = null;
  }
}
